import React from 'react'

const NonProfitCompnyFee = ({paymentRangeList}) => {
  return (
    <div
    className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
    id="exampleModalEdit"
    tabIndex={-1}
    aria-labelledby="exampleModalLabel"
    aria-modal="true"
    role="dialog"
  >
    <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
      <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
        <div className="flex justify-end">
          <svg
            data-bs-dismiss="modal"
            aria-label="Close"
            className="text-primary-blue h-8 w-8"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
            />
          </svg>
        </div>
        <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
        
        {/* <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        दर्ता शुल्क सम्बन्धि पूर्ण जानकारी 
  </h1> */}

<div className="border-primary-red m-5 rounded-md border">
      <p className="text-primary-blue text-center border-primary-blue border-b-2 p-3 font-bold md:!text-xl">
         Non Profit Company 
          <span className="text-primary-red underline ml-2">दर्ता शुल्क सम्बन्धि पूर्ण जानकारी</span>
        </p>
         {
        
         }
        <p className=' text-primary-blue p-3'>
        मुनाफा वितरण नगर्ने कम्पनी दर्ता गर्दा कुनै पुँजी उल्लेख गर्न जरुरी हुँदैन
सदस्यहरु संग संकलन गरिएको लेवी तथा सदस्यता शुल्क मात्र उल्लेख गर्दा हुने
भएकोले {paymentRangeList[0]?.range_end}जना सम्म सदस्यहरु भएमा <span className='text-red-600'>रु.{paymentRangeList[0]?.amount}|– </span> मात्र ।
</p>        </div>
  </div>
            
            </div>
          </div>
        </div>
  )
}

export default NonProfitCompnyFee